import logo from '/public/assets/logo-four-peaks.png';
import favicon from '/public/assets/favicon.png';
import { colors } from '#shared/themes/lightTheme';
import { convertKeyToCssVariables } from '#shared/utils/convertKeyToCssVariables';
import { initializeFonts } from '#shared/utils/initializeFonts';
import { initSessionSync } from '#app/admin/utils/sessionSync';
export default {
  config: {
    head: {
      favicon
    },
    auth: {
      logo
    },
    theme: {
      light: {
        colors
      }
    },
    locales: ['fr']
  },
  register() {},
  bootstrap() {
    convertKeyToCssVariables(colors);
    initializeFonts();
    initSessionSync();
  }
};